import { colors } from '@lmc/common/constants'
import { EmarModuleCard, FamilyPlanModuleCard, IconType } from '@lmc/ui-kit'
import { colours } from '@lmc/ui-kit/src/config/theme'
import type React from 'react'
import { PaywallTemplateWrapper } from '../../../../components/generic/PaywallTemplateWrapper'

type StateProps = {}

const HandoversPaywallComponent: React.FC<StateProps> = () => {
  return (
    <PaywallTemplateWrapper
      backgroundColor={colours.status.popout}
      title="Handovers"
      subTitle="Ensure safe and effective working. Handovers reduce miscommunication and help mitigating risks. Incidents are automatically added to handovers and you can monitor who’s read the report."
      bodyText="Support a smooth transition with shift summaries."
      icon={IconType.HandoversHexagon}
      videoUrl="https://www.youtube.com/embed/2XCgAbKwzvQ"
      articles={[
        {
          title: 'How do handovers work?',
          subtitle: 'View Article',
          icon: 'SettingOutlined',
          id: 'testId1',
          link: 'https://support.logmycare.co.uk/en/articles/2888761-how-do-i-flag-or-un-flag-a-log-for-handover',
          iconBackgroundColour: colors.orange,
          iconColour: colors.white
        },
        {
          title: 'How do I finalise a handover?',
          subtitle: 'View Article',
          icon: 'QuestionCircleOutlined',
          id: 'testId2',
          link: 'https://support.logmycare.co.uk/en/articles/2889205-how-do-i-finalise-a-handover-report',
          iconBackgroundColour: colors.green,
          iconColour: colors.white
        },
        {
          title: 'What other features do I get with Pro?',
          subtitle: 'View Article',
          icon: 'UserOutlined',
          id: 'testId3',
          link: 'https://support.logmycare.co.uk/en/collections/1681220-the-pro-plan',
          iconBackgroundColour: colors.purple,
          iconColour: colors.white
        }
      ]}
      leftModuleCard={<EmarModuleCard />}
      rightModuleCard={<FamilyPlanModuleCard />}
      findOutMoreURL="https://logmycare.co.uk/features/care-delivery"
      customLinkText="Read more"
    />
  )
}

export const HandoversPaywall = HandoversPaywallComponent
